module.exports = __webpack_public_path__ + "static/media/insight.b38b092a.png";